import React from 'react';
import PortfolioCourseRow from './PortfolioCourseRow';

export default function SubjectSection({ subject }) {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          marginBottom: 10,
        }}
      >
        <span
          style={{
            fontSize: 13,
            fontWeight: 700,
            color: 'var(--text-secondary)',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
          }}
        >
          {subject.subject}
        </span>
        <div style={{ flex: 1, height: 1, background: 'var(--border-subtle)' }} />
        <span style={{ fontSize: 12, color: 'var(--text-tertiary)' }}>
          {subject.courses.length} course{subject.courses.length === 1 ? '' : 's'}
        </span>
      </div>
      <div style={{ display: 'grid', gap: 10 }}>
        {subject.courses.map((c) => (
          <PortfolioCourseRow key={c.courseId} course={c} />
        ))}
      </div>
    </div>
  );
}
